import React from 'react'
import { UserLoginForm } from '../../form/loginForm/UserLoginForm'

export const Login = () => {
  return (
    <>
      <main>
        <UserLoginForm />
      </main>

    </>
  )
}
